import AddIcon from '@mui/icons-material/Add';

export const CreateTimeTrackingIcon = AddIcon;
